import {styled, Typography} from '@mui/material';
import {StyledGrid} from '../Grid';
import type {StyledContainerItemProps, StyledDescriptionItemProps} from './types';

const StyledContainerItem = styled(StyledGrid.Root)<StyledContainerItemProps>`
	margin-bottom: 16px;
	padding-bottom: 16px;
	border-bottom: ${({$isLast, theme}) =>
		$isLast ? 'none' : `1px solid ${theme.palette.divider}`};
`;

const StyledTitleItem = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 0.17px;
`;

const StyledDescriptionItem = styled(Typography)<StyledDescriptionItemProps>`
	color: ${({theme, $isLink}) =>
		$isLink ? theme.palette.primary.main : theme.palette.text.secondary};
	text-decoration: ${({$isLink}) => ($isLink ? 'underline' : 'none')};
	cursor: ${({$isLink}) => ($isLink ? 'pointer' : 'auto')};
	font-size: 14px;
	font-weight: 400;
	letter-spacing: 0.17px;
	white-space: ${({$isLink}) => ($isLink ? 'nowrap' : 'auto')};
	max-width: fit-content;
	overflow: ${({$isLink}) => ($isLink ? 'hidden' : 'auto')};
	text-overflow: ${({$isLink}) => ($isLink ? 'ellipsis' : 'auto')};
`;

export {StyledContainerItem, StyledDescriptionItem, StyledTitleItem};
